@if (serviceOptionType() === 'self send') {
  <app-self-send />
} @else if (serviceOptionType() === 'courier') {
  <app-courier-collection [claimType]="claimType()" />
} @else {
  @switch (vm.status) {
    @case ('waiting_for_parts') {
      <app-waiting-for-parts [statusChange]="step().statusChange" />
    }

    @case ('new_visit') {
      <app-new-visit
        [isFirstVisit]="vm.originalStatusIncludesFirst"
        [isTvRemoteReplacement]="vm.isTvRemoteReplacement"
        [claimType]="claimType()"
      ></app-new-visit>
    }

    @case ('remedial_work_required') {
      <app-remedial-work [claimType]="claimType()"></app-remedial-work>
    }

    @case ('sp_contact_customer') {
      <app-sp-contact-customer [claimType]="claimType()"></app-sp-contact-customer>
    }

    @case ('repair_in_progress') {
      <app-engineer-visit [claimType]="claimType()"></app-engineer-visit>
    }

    @case ('engineer_visit') {
      <app-engineer-visit [claimType]="claimType()"></app-engineer-visit>
    }

    @case ('out_card_left') {
      <app-out-card-left [claimType]="claimType()" />
    }

    @default {
      <section class="heading">
        <app-dot-pulse />
        <p class="body bold">{{ vm.status | statusNameMapping }}</p>
      </section>
    }
  }
}

@if (vm.rebooking || vm.trackable) {
  <section class="button-container mt-16">
    @if (vm.rebooking) {
      <app-button
        dataLabel="rebook"
        [buttonOptions]="{
          variant: 'primary',
          isLink: true,
          url: vm.rebookingURL,
        }"
        >Change the date
      </app-button>
    }

    @if (vm.trackable) {
      <app-button
        dataLabel="track"
        [buttonOptions]="{
          variant: 'secondary',
          isLink: true,
          url: vm.trackingURL,
        }"
        >Track my {{ vm.claimType | lowercase }}</app-button
      >
    }
  </section>
}

@if (vm.cancel) {
  <section>
    <div class="divider mt-16 mb-16"></div>
    <p class="body bold">No longer need a {{ vm.claimType | lowercase }}?</p>

    <app-button
      dataLabel="cancel"
      class="mt-8 cancel-button"
      [buttonOptions]="{
        variant: 'link',
      }"
      (click)="cancelClaim()"
    >
      <span>Cancel the {{ vm.claimType | lowercase }}</span>
    </app-button>
  </section>
}
